import React, { useState, useEffect, useCallback } from 'react';
import { getData, updateData } from '../../../services/admin/invoiceReceipt/invoiceInBankServices';
import { Button, Form } from 'react-bootstrap';
import Header from '../../../components/Layout/Header';
import Footer from '../../../components/Layout/Footer';
import Sidebar from '../../../components/Layout/Sidebar';
import Spinner from '../../../components/Spinner';
import Swal from 'sweetalert2';

const InvoiceInBank = () => {
  const [loading, setLoading] = useState(true);
  const [errors, setErrors] = useState({});
  const [form, setForm] = useState({ 
    id: null,
    beneficiarys_name: '',
    beneficiarys_address: '',
    bank_name: '',
    bank_address: '',
    beneficiarys_account_number: '',
    in_swift_code: '',
    in_branch_code: '',
    in_iban_bic_code: '',
    status: false,
  });
  
  // Fetch data list
  const fetchData = useCallback(async () => {
    try {
      const data = await getData();
      setForm(data[0]);
    } catch (error) {
      console.error('Failed to fetch data:', error);
    }
  }, []);

  useEffect(() => {
    const fetchDataAsync = async () => {
      setLoading(true); 
      await fetchData();
      // Optional 2 second delay
      await new Promise((resolve) => setTimeout(resolve, 1000));
      setLoading(false); 
    };
  
    fetchDataAsync();
  }, [fetchData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    // Clear any previous errors for this field
    setErrors((prev) => ({ ...prev, [name]: '' }));
  };

  const validateForm = () => {
        const newErrors = {};
        // Check if code or name fields are empty or just whitespace
        if (!form.beneficiarys_name || !form.beneficiarys_name.trim()) {newErrors.beneficiarys_name = 'Name is required';}
        if (!form.beneficiarys_address || !form.beneficiarys_address.trim()) {newErrors.beneficiarys_address = 'Address is required';}
        if (!form.bank_name || !form.bank_name.trim()) {newErrors.bank_name = 'Bank name is required';}
        if (!form.bank_address || !form.bank_address.trim()) {newErrors.bank_address = 'Bank Address is required';}
        if (!form.in_swift_code || !form.in_swift_code) {newErrors.in_swift_code = 'swift code is required';}
        if (!form.in_branch_code || !form.in_branch_code) {newErrors.in_branch_code = 'branch code is required';}
        if (!form.in_iban_bic_code || !form.in_iban_bic_code) {newErrors.in_iban_bic_code = 'iban is required';}
        if (form.beneficiarys_account_number && isNaN(form.beneficiarys_account_number)) {
        newErrors.beneficiarys_account_number = 'Account number must be a number';
        }
        // Set the error state if there are validation errors
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;  // Return true if no errors
    };

  const handleSubmit = async (e) => {
    if (!validateForm()) return;
    try {
      await updateData(form);
      fetchData();
    // ✅ Show success alert with auto-close
    Swal.fire({
        icon: 'success',
        title: 'Success',
        text: `Invoice India bank details ${'edit' === 'add' ? 'added' : 'updated'} successfully!`,
        timer: 2000, // 2 seconds
        showConfirmButton: false,
    });
    } catch (error) {
    console.error('Error during form submission:', error);
    Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Something went wrong while submitting the form!',
    });
    }
  };

  return (
    <div className="d-flex">
      <Sidebar />
      <div className="main-content w-100">
        <Header />
        {loading ? (
          <div
            className="d-flex justify-content-center align-items-center w-100"
            style={{ minHeight: "300px" }}
          >
            <Spinner/>
          </div>
                  ) :(
        <div>
        <div className="container-fluid p-4">
          <div className="row">
            <div className="col-8">
            <p className='fs-4 text-dark'>PDF Generation / Invoice Receipt / Configuration / Indian Bank</p>
            </div>
          </div>

          <div className="bg-white p-3 shadow">
          <Form>
            <Form.Group className="mb-3">
              <div className='row'>
                <div className='col-md-4'>
                  <Form.Label className='fs-5 text-dark'>Beneficiarys Name</Form.Label>
                  <Form.Control type="text" name="beneficiarys_name" value={form.beneficiarys_name} onChange={handleChange} isInvalid={!!errors.beneficiarys_name}/>
                  <Form.Control.Feedback type="invalid">  {errors.beneficiarys_name} </Form.Control.Feedback>
                </div>
                <div className='col-md-4'>
                  <Form.Label className='fs-5 text-dark'>Beneficiarys Address</Form.Label>
                  <Form.Control type="text" name="beneficiarys_address" value={form.beneficiarys_address} onChange={handleChange} isInvalid={!!errors.beneficiarys_address}/>
                  <Form.Control.Feedback type="invalid">  {errors.beneficiarys_address} </Form.Control.Feedback>
                </div>
                <div className='col-md-4'>
                  <Form.Label className='fs-5 text-dark'>Beneficiarys Account Number<small className='fs-5 text-danger'> *</small></Form.Label>
                  <Form.Control type="number" name="beneficiarys_account_number" value={form.beneficiarys_account_number} onChange={handleChange} isInvalid={!!errors.beneficiarys_account_number}/>
                  <Form.Control.Feedback type="invalid">  {errors.beneficiarys_account_number} </Form.Control.Feedback>
                </div>
              </div>
            </Form.Group>
            <Form.Group className="mb-3">
              <div className='row'>
                <div className='col-md-4'>
                  <Form.Label className='fs-5 text-dark'>Bank Name</Form.Label>
                  <Form.Control type="text" name="bank_name" value={form.bank_name} onChange={handleChange} isInvalid={!!errors.bank_name}/>
                  <Form.Control.Feedback type="invalid">  {errors.bank_name} </Form.Control.Feedback>
                </div>
                <div className='col-md-8'>
                  <Form.Label className='fs-5 text-dark'>Bank Address<small className='fs-5 text-danger'> *</small></Form.Label>
                  <Form.Control type="text" name="bank_address" value={form.bank_address} onChange={handleChange} isInvalid={!!errors.bank_address}/>
                  <Form.Control.Feedback type="invalid">  {errors.bank_address} </Form.Control.Feedback>
                </div>
              </div>
            </Form.Group>
            <Form.Group className="mb-3">
              <div className='row'>
                <div className='col-md-4'>
                  <Form.Label className='fs-5 text-dark'>SWIFT Code</Form.Label>
                  <Form.Control type="text" name="in_swift_code" value={form.in_swift_code} onChange={handleChange} isInvalid={!!errors.in_swift_code}/>
                  <Form.Control.Feedback type="invalid">  {errors.in_swift_code} </Form.Control.Feedback>
                </div>
                <div className='col-md-4'>
                  <Form.Label className='fs-5 text-dark'>Branch Code</Form.Label>
                  <Form.Control type="text" name="in_branch_code" value={form.in_branch_code} onChange={handleChange} isInvalid={!!errors.in_branch_code}/>
                  <Form.Control.Feedback type="invalid">  {errors.in_branch_code} </Form.Control.Feedback>
                </div>
                <div className='col-md-4'>
                  <Form.Label className='fs-5 text-dark'>IBAN and BIC</Form.Label>
                  <Form.Control type="text" name="in_iban_bic_code" value={form.in_iban_bic_code} onChange={handleChange} isInvalid={!!errors.in_iban_bic_code}/>
                  <Form.Control.Feedback type="invalid">  {errors.in_iban_bic_code} </Form.Control.Feedback>
                </div>
                <div className='col-md-4'>
                  <Form.Group className="mb-3">
                    <Form.Label className='fs-5 text-dark'>Status</Form.Label>
                    <Form.Select
                      name="status"
                      value={form.status ? '1' : '0'}
                      onChange={(e) => {
                        const val = e.target.value === '1' ? true : false;
                        setForm(prev => ({ ...prev, status: val }));
                      }}
                    >
                      <option value="1">Active</option>
                      <option value="0">Inactive</option>
                    </Form.Select>
                  </Form.Group>
                  </div>
              </div>
            </Form.Group>
            <Button variant="primary" onClick={handleSubmit}> Save changes </Button>
          </Form>
          </div>
        </div>
        <Footer />
        </div>
        )};
      </div>
    </div>
  );
};

export default InvoiceInBank;